var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83105 8.49268H13.1586",
    stroke: "#F8F8F8",
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49512 3.82861L13.1589 8.49236L8.49512 13.1561",
    stroke: "#F8F8F8",
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.99,
    height: 15.99,
    fill: "white",
    transform: "translate(0.5 0.497559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.ebc1dc4ffd14ba2027a73b8465f5ed8e.svg";
export { ForwardRef as ReactComponent };